export const E_APPLICATIONS_RESET_STATE = 'E_APPLICATIONS_RESET_STATE';
export const E_APPLICATIONS_CURRENT_ITEM = 'E_APPLICATIONS_CURRENT_ITEM';

export const E_APPLICATIONS_REQUEST_LOADING = 'E_APPLICATIONS_REQUEST_LOADING';
export const E_APPLICATIONS_REQUEST_SUCCESS = 'E_APPLICATIONS_REQUEST_SUCCESS';
export const E_APPLICATIONS_REQUEST_FAILED = 'E_APPLICATIONS_REQUEST_FAILED';

export const E_APPLICATIONS_CURRENT_ACTION = 'E_APPLICATIONS_CURRENT_ACTION';
export const E_APPLICATIONS_RESET_ACTION = 'E_APPLICATIONS_RESET_ACTION';